<div class="chart-container">
  <ngx-charts-area-chart
    [results]="chartData"
    [legend]="false"
    [curve]="curve"
    [customColors]="customColors"
    [showXAxisLabel]="false"
    [showYAxisLabel]="false"
    [xAxis]="true"
    [yAxis]="true"
    [gradient]="true"
    [showGridLines]="false"
    [yScaleMin]="min"
    [yScaleMax]="max"
    [wrapTicks]="true"
    [xAxisTickFormatting]="formatTime"
    [yAxisTickFormatting]="formatTemp">
    <ng-template #tooltipTemplate let-model="model">
      @if (getTooltipPoint(model); as point) {
        <div class="chart-tooltip">
          <div class="chart-tooltip__label">{{ formatTooltipDate(point) }}</div>
          <div>{{ 'weather.precipitation' | translate }}: {{ point.value | localizedNumber:'1.0-0' }} %</div>
          <div>{{ 'weather.precipitationAmount' | translate }}: {{ point.precipitationAmount | localizedNumber:'1.0-1' }} mm</div>
        </div>
      }
    </ng-template>

    <ng-template #seriesTooltipTemplate let-model="model">
      @if (getTooltipPoint(model); as point) {
        <div class="chart-tooltip">
          <div class="chart-tooltip__label">{{ formatTooltipDate(point) }}</div>
          <div>{{ 'weather.precipitation' | translate }}: {{ point.value | localizedNumber:'1.0-0' }} %</div>
          <div>{{ 'weather.precipitationAmount' | translate }}: {{ point.precipitationAmount | localizedNumber:'1.0-1' }} mm</div>
        </div>
      }
    </ng-template>
  </ngx-charts-area-chart>
</div>
